/* unplugin-vue-components disabled */import { render } from "./style5.vue?vue&type=template&id=49ae780c&scoped=true"
import script from "./style5.vue?vue&type=script&lang=js"
export * from "./style5.vue?vue&type=script&lang=js"

import "./style5.vue?vue&type=style&index=0&id=49ae780c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ae780c"]])

export default __exports__